import { render, staticRenderFns } from "./BatteryFilter.vue?vue&type=template&id=f8868df2"
import script from "./BatteryFilter.vue?vue&type=script&lang=js"
export * from "./BatteryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports